import "./components/_slider";
import "./components/_popup";
import "./utility/_cookies";
import { faq } from "./components/_faq";
import {Slider} from "./components/_slider2";

$(function() {
    $(".news-list").slider({
        breakpoints: [
            {width: 600, count: 1},
            {width: 9999900, count: 3}
        ],
        swipeHorizontal: false,
        elementSelector : '.news'
    });

    $(".partners-list").slider({
        breakpoints: [
            {width: 400, count: 2},
            {width: 640, count: 4},
            {width: 9999900, count: 8}
        ],
        swipeHorizontal: false,
        elementSelector : '.partners-list-el'
    })

    if ($(".m-section-subject-slider").length) {
        new Slider(".m-section-subject-slider", {
            mainClass: 'slider-2',
            pauseTime: 5000,
            enableSwipe: true
        });
    }

    faq();

    //funkcje defer
    PTWP.defer.emit({});
});
